/**
 * Index de Servicios
 * El objetivo es organizar las funciones por tipos o módulos, así solo se importan las funciones a usar de la interfaz
 * https://alligator.io/react/index-js-public-interfaces/
 */

export * from './environments/environment.service'
export * from './auth/user.service'
export * from './locations/location.service'
export * from './hotels/hotel.service'
export * from './bookings/booking.service'
export * from './availabilities/availability.service'
export * from './rateplan/rateplan.service'
export * from './rate/rate.service'
export * from './handlers/request.handler'
export * from './inventory/inventory.service'
export * from './logs/log.service'
export * from './logstock/logstock.service'
export * from './childspolicies/childspolicies.service'



// WEBPACK FOOTER //
// ./src/utils/services/index.js